module.exports = __webpack_public_path__ + "img/logo.b705f640.svg";